<template>
  <div class="focused-panel">
    <div class="d-flex polytron-toolbar">
      <!--<div class="p-2">{{wellFeature ? wellFeature.get('ident') : 'No well selected'}}</div>-->
      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Create target" :pressed.sync="addEnabled" variant="primary">
        <icon scale=".6" name="plus"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Select target" :pressed.sync="selectEnabled" variant="primary">
        <icon scale=".6" name="hand-pointer"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" :id="'undo-'+editorIdent" :disabled="!historyChanges" @click="undo" variant="primary">
        <icon scale=".6" name="undo"/>
      </b-btn>
      <b-tooltip v-if="historyChanges" :target="'undo-'+editorIdent" placement="top">
        Undo
      </b-tooltip>


      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Move target" :disabled="!wellFeatureSelected" :pressed.sync="dragEnabled"
             variant="primary">
        <icon scale=".6" name="arrows-alt"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit attributes" :disabled="!wellFeatureSelected" :pressed.sync="editEnabled"
             variant="primary">
        <icon scale=".6" name="pencil-alt"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" @click="deleteFetaures" v-b-tooltip.hover.auto title="Delete target" :disabled="!wellFeatureSelected"
             variant="primary">
        <icon scale=".6" name="times"/>
      </b-btn>

      <!--<b-btn :pressed.sync="ldEnabled" v-b-tooltip.hover.auto title="Load dependant layers"-->
      <!--variant="primary">-->
      <!--<icon name="link"/>-->
      <!--</b-btn>-->

      <!--<b-btn :disabled="!hasChanges" variant="primary" @click="otfCommentShow=true">-->
      <!--<icon :name="saving ? 'spinner' : 'save'" :pulse="saving"/>-->
      <!--</b-btn>-->
    </div>

    <b-modal v-model="showForm" @ok="onOK" @cancel="onCancel" :ok-disabled="!validName">
      <div slot="modal-header">
        <label>{{formTitle}}</label>
      </div>
      <b-form class="p-2">

        <b-form-group label="Name:" label-for="constraingMinor">
          <b-form-input id="wellIdent"
                        v-model="wellAttrs['name']"
                        required
                        :state="validName"
                        aria-describedby="uniqeCampName"
                        placeholder="Enter name"

          ></b-form-input>
        <b-form-invalid-feedback id="uniqeCampName">
          <!-- This will only be shown if the preceeding input has an invalid state -->
          Enter a unique camp name
        </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Target type:" label-for="targetType">
          <b-form-select :options="targets" id="targetType"
                         v-model="wellAttrs['target']"
                         required
                         placeholder="Please, select target type"

          ></b-form-select>
        </b-form-group>

        <b-form-group label="Gas dest:" label-for="gasDest">
          <b-form-select :options="gasDests" id="gasDest"
                         v-model="wellAttrs['gas_dest']"
                         required
                         placeholder="Please, select gas dest"

          ></b-form-select>
        </b-form-group>

        <b-form-group label="Property:" label-for="constraingMinor">
          <b-form-input id="wellIdent"
                        v-model="wellAttrs['property']"
                        required

          ></b-form-input>
        </b-form-group>
      </b-form>
    </b-modal>

  </div>
</template>

<script>
  import 'vue-awesome/icons/arrows-alt'
  import 'vue-awesome/icons/times'
  import 'vue-awesome/icons/plus'
  import 'vue-awesome/icons/save'
  import 'vue-awesome/icons/check'
  import Vue from 'vue'

  import FeatureEditorMixin from '../../../mixins/FeatureEditorMixin'
  import ConstraintsForm from './ConstraintsForm'
  import uuidV1 from 'uuid/v1'

  export default {
    name: 'logitron',
    components: {
      ConstraintsForm
    },
    mixins: [FeatureEditorMixin],
    data () {
      return {
        markLastModified: false,
        featureId: null,
        addPolyEnabled: false,
        addLineEnabled: false,
        addPointEnabled: false,
        identName: 'name',
        wellAttrs: {
          name: null,
          property: null,
          target: null,
          gas_dest: null
        },
        targets: [
          {
            'text': 'Laydown',
            'value': 'laydown'
          },
          {
            'text': 'Camp',
            'value': 'camp'
          },
          {
            'text': 'Central laydown',
            'value': 'central_laydown'
          }
        ],
        gasDests: [],
        wellLayerName: 'v4:camps',
        geomType: 'Point',
        geometryName: 'geom',
        idName: 'gid',
        campNames: []
      }
    },
    mounted () {
      this.$options.mixins[0].mounted.call(this)
      this.fetchGasDests()
      this.getCampNames()
    },
    methods: {
      getCampNames () {
        this.wellLayer.getSource().getFeatures().forEach(f => this.campNames.push({name: f.get('name'), id: f.get('gid')}))
      },
      fetchGasDests () {
         this.$http.get('/api/layers/list-gas-dests')
           .then(res => {
             this.gasDests = res.body.map(d => {
               return {
                 value: d,
                 text: d
               }
             })
           }, res => {
             this.$notify({
               title: 'ERROR',
               text: 'Could not load gas dest list',
               type: 'error'
             })
           })
      },
      addFeature (e) {
        this.formTitle = 'Create target'
        this.showForm = true
        this.wellFeature = e.feature.clone()
        this.drawingFeature = e.feature
        this.wellFeature.set('ident', `${this.editorIdent}-${uuidV1()}`)
      },
      validateProps () {
        let valid = true
        if (!this.wellAttrs['target']) {
          this.$notify({
            title: 'ERROR: inavlid target type',
            text: 'Target typo is required',
            type: 'error'
          })
          valid = false
        }

        if (!this.wellAttrs['gas_dest']) {
          this.$notify({
            title: 'ERROR: inavlid gas dest',
            text: 'Gas dest is required',
            type: 'error'
          })
          valid = false
        }
        return valid
      },
      editProps (feature) {
        this.featureId = feature.get('gid')
        FeatureEditorMixin.methods.editProps.call(this, feature)
      },
      // addFeature (e) {
      //   this.formTitle = 'Create constraint'
      //   this.showForm = true
      //   this.wellFeature = e.feature.clone()
      //   this.drawingFeature = e.feature
      //   this.wellFeature.set('ident', `${this.editorIdent}-${uuidV1()}`)
      // },
    },
    watch: {
      currentEditor (val) {
        if (val !== this.editorIdent) {
          this.addEnabled = false
          this.selectEnabled = false
          this.addLineEnabled = false
          this.addPointEnabled = false
          this.addPolyEnabled = false
        }
      },
      selectTool (val) {
        if (val) {
          this.addLineEnabled = false
          this.addPointEnabled = false
          this.addPolyEnabled = false
        }
      }
    },
    computed: {
      selectTool () {
        return this.selectEnabled
      },
      validName () {
        let v = this.campNames.find(c => c.name === this.wellAttrs['name'])
        return v === undefined || v.id === this.wellFeature.get('gid')
      }
    }
  }
</script>

<style lang="scss">
  .was-validated .form-control:valid, .form-control.is-valid, .was-validated .custom-select:valid, .custom-select.is-valid {
    border: 1px solid #ced4da;
  }
</style>



// WEBPACK FOOTER //
// src/components/map/designotron/Logitron.vue